export const getOneIndexing = (index: string | number) => {
  return Number(index) + 1;
};
